import { forwardRef, type InputHTMLAttributes } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  borderless?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, borderless = false, ...props }, ref) => (
    <input
      autoComplete="nope"
      className={cnTwMerge(
        "flex h-11 w-full gap-2 items-center break-all justify-between outline:none rounded-companyBorderRadius border border-border/primary bg-background/primary pl-5 pr-4 py-2.5 body-base-regular text-text/primary placeholder:text-text/secondary disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 focus:border-brand-default outline-none focus:outline-none focus:ring-0 focus:ring-brand-default focus:ring-offset-0 hover:border-brand-default",
        borderless &&
          "border-0 bg-transparent h-auto p-0 focus:border-0 hover:border-0 focus:ring-0",
        className,
      )}
      ref={ref}
      type={type}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
